import { CustomElement } from '@aurelia/runtime-html';
import "./create.scss";
import * as d1 from "../../components/spinner/spinner.ts";
export const name = "create";
export const template = "<template>\n  \n  <div class=\"container\" style=\"margin-top:2rem\">\n    <spinner busy.to-view=\"true\"></spinner>\n  </div>\n</template>\n";
export default template;
export const dependencies = [ d1 ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
